import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { PaymentQrMerchantsRepository } from '@app/domain/ports/payment-qr-merchants.repository';
import type { QrMerchantOptions } from '@app/domain/models/payments-qr/qr-merchant.model';
import {
  QR_MERCHANTS_LIMIT,
  QR_OWN_ACCOUNT_COBRA_A,
  buildQrMerchantOptions,
} from '@app/domain/models/payments-qr/qr-merchant';

/**
 * Opciones del campo "Comercio" del cobro QR.
 *
 * Pide los candidatos con los filtros del servidor (RS2) y vuelve a filtrar en
 * cliente (RS3): el filtro remoto reduce la carga, el local es la garantía — si
 * el back ignorara un parámetro desconocido o comparara `cobra_a` distinto, la
 * regla se cumple igual. `truncated` avisa que el servidor tiene más de los
 * `limit` devueltos (RS7).
 *
 * Provisto en la ventana (no `root`): se crea y destruye con ella.
 */
@Injectable()
export class ListQrMerchantsUseCase {
  private readonly repository = inject(PaymentQrMerchantsRepository);

  execute(): Observable<QrMerchantOptions> {
    return this.repository
      .listCandidates({ isActive: true, cobraA: QR_OWN_ACCOUNT_COBRA_A, limit: QR_MERCHANTS_LIMIT })
      .pipe(
        map((page) => ({
          options: buildQrMerchantOptions(page.results),
          truncated: page.count > page.results.length,
          limit: QR_MERCHANTS_LIMIT,
        })),
      );
  }
}
